// GenLoyal: el href vivo ya trae el cache-bust (`?v=N`) que puso vueapp.html.erb, así que se
// arrastra en vez de repetirlo acá — si no, habría que acordarse de bumpear los dos lados.
const cacheBustOf = favicon => new URL(favicon.href).search;

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png${cacheBustOf(favicon)}`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = `/favicon-${favicon.sizes[[0]]}.png${cacheBustOf(favicon)}`;
        favicon.href = oldFileName;
      });
    }
  });
};
